module.exports = __webpack_public_path__ + "02_long_gray.246fefe6.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer5/02_long_gray.png
// module id = 9aK1
// module chunks = 0